import $ from 'jquery';
import { fetchEditorBackgrounds } from '~graphql/controllers';
import { displaySidebarBackgrounds } from '~src/sidebar/index';
import { getState, modifyState } from '~src/state';

let lastScrollTop;

const loader =
  '<div class="text-center" style="grid-column: span 2;"><div class="spinner-grow mt-3 mb-3" role="status"><span class="sr-only">Caricamento...</span></div></div>';

export const fetchEditorBackgroundsNextPage = async () => {
  $('#editor-sidebar-backgrounds').append(loader);
  $('#editor-sidebar-backgrounds-custom').append(loader);

  $('#fetchMoreBackgrounds').attr('disabled', true);
  const currentTag = getState('sidebarCurrentBackgroundsTag', 'NO_TAG');

  modifyState('INFINITE_SCROLLING_EDITOR_BACKGROUNDS_ON', true);

  const editorBackgroundsDefaultAfterCursor = getState(
    `${currentTag}.editorBackgroundsDefaultAfterCursor`
  );
  const editorBackgroundsAfterCursor = getState(
    `${currentTag}.editorBackgroundsAfterCursor`
  );
  const { backgrounds } = await fetchEditorBackgrounds({
    editorBackgroundsDefaultAfterCursor,
    editorBackgroundsAfterCursor,
    forceFetch: false,
  });

  window.editorConfig.sidebarBackgrounds[
    currentTag
  ].items = window.editorConfig.sidebarBackgrounds[currentTag].items.concat(
    backgrounds.items
  );

  await displaySidebarBackgrounds();

  setTimeout(() => {
    modifyState('INFINITE_SCROLLING_EDITOR_BACKGROUNDS_ON', false);
    $('#fetchMoreBackgrounds').attr('disabled', false);
  }, 250);
};

export const handleEditorBackgroundsScroll = () => {
  document
    .querySelector('#sidebar-content')
    .addEventListener('scroll', async () => {
      const activeSidebarTab = $('.active[data-tab-target]').data('tab-target');

      if (activeSidebarTab === 'tab-manifesti') {
        const contentHeight = $('#sidebar-box-backgrounds').height();
        const scrollTop = $('#sidebar-content').scrollTop();

        const currentTag = getState('sidebarCurrentBackgroundsTag', 'NO_TAG');

        if (
          scrollTop > lastScrollTop &&
          scrollTop + 600 >= contentHeight &&
          !getState('INFINITE_SCROLLING_EDITOR_BACKGROUNDS_ON') &&
          (getState(`${currentTag}.editorBackgroundsDefaultHasNextPage`) ||
            getState(`${currentTag}.editorBackgroundsHasNextPage`))
        ) {
          await fetchEditorBackgroundsNextPage();
        }

        lastScrollTop = scrollTop;
      }
    });
};
